export type ChatRefreshV2Config = {
	isNewAllConversationScreenEnabled: boolean;
	isSpinnerOverlayConversationIconEnabled: boolean;
};

export const initialState: ChatRefreshV2Config = {
	isNewAllConversationScreenEnabled: false,
	isSpinnerOverlayConversationIconEnabled: false,
};

export const getChatRefreshV2Config = () => {
	return {
		isNewAllConversationScreenEnabled: false,
		isSpinnerOverlayConversationIconEnabled: false,
	};
};
